<template>
  <el-row>
    <el-form :model="intranetClueCarRecordItemForm"
             ref="intranetClueCarRecordItemRef"
             :rules="rules"
             @onSelectInfo="onSelectInfo"
             addAction="clueCar/saveClueCarRecord.action"
             editAction="clueCar/updateClueCarRecord.action"
             selectAction="clueCar/selectClueCarRecord.action"
             label-width="150px"
             style="width:50%"
             v-form>
      <el-form-item label="收车人姓名：" prop="name">
        <el-input type="text"  v-model="intranetClueCarRecordItemForm.name"></el-input>
      </el-form-item>
      <el-form-item label="收车人电话：" prop="phone">
        <el-input type="number" v-model="intranetClueCarRecordItemForm.phone"></el-input>
      </el-form-item>
      <el-form-item label="收车状态：" prop="status">
        <el-select v-model="intranetClueCarRecordItemForm.status">
          <el-option label="正在收车" :value="1"></el-option>
          <el-option label="排队收车" :value="2"></el-option>
          <el-option label="放弃收车" :value="3"></el-option>
          <el-option label="成功收车" :value="4"></el-option>
          <el-option label="锁定看车" :value="5"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="收车报价" prop="quotePrice">
        <el-input v-model="intranetClueCarRecordItemForm.quotePrice"></el-input>
      </el-form-item>
      <el-form-item label="收车备注：" prop="remark">
        <el-input type="textarea" v-model="intranetClueCarRecordItemForm.remark"></el-input>
      </el-form-item>
      <el-form-item label="记录人:" prop="maintenanceEmployeeSnapid">
        <el-select v-model="intranetClueCarRecordItemForm.maintenanceEmployeeSnapid" @change="switchMainName">
          <el-option
                  v-for="item in maintenanceEmployees"
                  :key="item.maintenanceEmployeeSnapid"
                  :label="item.maintenanceName"
                  :value="item.maintenanceEmployeeSnapid">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary">确定</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </el-form-item>
    </el-form>
  </el-row>
</template>

<script>
import BasicPager from '@/mixins/BasicPager'
import BasicModel from '@/framework/basic/BasicModel'
export default {
  name: 'intranetClueCarRecordItem',
  extends: BasicPager,
  components: {},
  data: function () {
    return {
      maintenanceEmployees: [],
      rules: {
        maintenanceEmployeeSnapid: [
          { required: true, message: '请选择记录人', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号' }
        ],
        status: [
          { type: 'number', required: true, message: '请选择收车状态' }
        ],
        quotePrice: [
          { required: true, message: '报价不能为空' }, { max: 20, message: '报价字符不能大于20！' }
        ]

      },
      intranetClueCarRecordItemForm: {
        id: null,
        maintenanceName: null,
        maintenanceEmployeeSnapid: null
      }
    }
  },
  created () {
    this.intranetClueCarRecordItemForm.id = this.$route.query.id
    this.intranetClueCarRecordItemForm.clueCarId = this.$route.query.clueCarId
    this.findMaintenceUsersList()
    if (!this.$route.query.id) {
      let userInfo = JSON.parse(localStorage.userInfo)
      this.intranetClueCarRecordItemForm.maintenanceName = userInfo.realName
      this.intranetClueCarRecordItemForm.maintenanceEmployeeSnapid = userInfo.employeeSnapId
    }
  },
  methods: {
    switchMainName (data) {
      let maintenanceObject = this.maintenanceEmployees.find(function (item) {
        return item.maintenanceEmployeeSnapid === data
      })

      this.intranetClueCarRecordItemForm.maintenanceName = maintenanceObject.maintenanceName
    },
    findMaintenceUsersList () {
      let _this = this
      let params = { }
      let listener = {
        success: function (dataInfo) {
          if (dataInfo.success) {
            _this.maintenanceEmployees = dataInfo.datas
          }
        }

      }
      // 维护人列表
      BasicModel.post(_this, '/clueCar/findMaintenceUsersList.action', params, listener)
    },
    onFilterParams: function (params) {

    },
    onSelectInfo: function (dataInfo) {
    }
  },
  filters: {}

}
</script>

<style scoped>

</style>
